import React, { useCallback, useEffect } from "react";
import { RouteComponentProps, navigate } from "@reach/router";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigationPaths } from "newui/features/Auth/hooks/useNavigationPaths";
import { RatingWorkflowProvider } from "../context/RatingWorkflowContext";
import { RatingWorkflow } from "../components/RatingWorkflow";
import { trackRatingStarted } from "newui/features/MySuppliers/utils/analytics";

interface NewRatingPageProps extends RouteComponentProps {
	supplierId?: string;
}

export const NewRatingPage: React.FC<NewRatingPageProps> = ({
	supplierId,
}) => {
	const { clientPaths } = useNavigationPaths();
	const supplierIdNum = supplierId ? parseInt(supplierId, 10) : null;

	useEffect(() => {
		if (supplierIdNum) {
			trackRatingStarted(supplierIdNum);
		}
	}, [supplierIdNum]);

	const handleBack = useCallback(() => {
		if (clientPaths) {
			navigate(clientPaths.mySuppliers.list);
		}
	}, [clientPaths]);

	const handleComplete = useCallback(() => {
		if (clientPaths) {
			navigate(clientPaths.mySuppliers.list);
		}
	}, [clientPaths]);

	const initialSupplier =
		supplierIdNum && !isNaN(supplierIdNum)
			? { supplierId: supplierIdNum, supplierName: "" }
			: null;

	return (
		<div className="p-6" data-testid="new-rating-page">
			<button
				type="button"
				onClick={handleBack}
				className="mb-4 inline-flex items-center gap-2 text-sm text-gray-600 transition-colors hover:text-gray-900"
			>
				<FiArrowLeft className="h-4 w-4" />
				Back to Supplier Hub
			</button>

			<h1 className="mb-6 text-2xl font-semibold text-gray-900">
				Rate Supplier Performance
			</h1>

			<RatingWorkflowProvider initialSupplier={initialSupplier}>
				<RatingWorkflow onComplete={handleComplete} />
			</RatingWorkflowProvider>
		</div>
	);
};
